<template>
  <div class="">
    <FilePond
      name="file"
      ref="pond"
      :label-idle="labelIdle"
      :allow-multiple="true"
      :allow-revert="false"
      :accepted-file-types="acceptedFileTypes"
      :oninitfile="onSubmit"
      :onprocessfile="onProcessFile"
      :onprocessfiles="onProcessFiles"
      :instant-upload="true"
      :server="serverOptions"
    />
  </div>
</template>

<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import { getCookie } from '@/utils/helpers';

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

export default {
  name: 'CreateMediaAssets',

  components: {
    FilePond,
  },

  props: {
    contactRequestId: {
      type: String,
      required: true,
    },
    acceptedFileTypes: {
      type: String,
      default: 'image/*, application/pdf, video/mp4',
    },
    onSubmit: {
      type: Function,
      default: null,
    },
    onSubmitted: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      labelIdle:
        "Drop files here or <span class='underline cursor-pointer'>Browse</span> to upload",
      active: false,
      serverOptions: {
        process: {
          url: `/api/v1/contact-requests/${this.contactRequestId}/attachments`,
          method: 'POST',
          withCredentials: true,
          headers: {
            'X-Xsrf-Token': getCookie('XSRF-TOKEN'),
          },
          onload: async (response) => {
            const { data = null } = JSON.parse(response);

            if (!data) {
              return;
            }

            try {
              await this.$store.dispatch({
                type: 'ui/contactMedia/save',
                contactRequestId: this.contactRequestId,
                medium: data,
              });
            } catch (error) {
              //
            }
          },
          onerror: null,
        },
        revert: null,
        restore: null,
        load: null,
        fetch: null,
      },
    };
  },

  methods: {
    setActive(active) {
      this.active = active;
      if (typeof this.onActive === 'function') {
        this.onActive(active);
      }
    },
    onInitFile() {
      this.setActive(true);
    },
    onProcessFile(error, file) {
      setTimeout(() => {
        if (file.status === 5) {
          this.$refs.pond.removeFile(file.id);
        }

        if ((this.$refs?.pond?.getFiles()?.length || 0) === 0) {
          this.setActive(false);
        }
      }, 1500);
    },
    onProcessFiles() {
      this.setActive(false);
      this.$emit('created');
    },
  },
};
</script>

<style>
.filepond--root {
  @apply mb-0;
}
</style>
